// Der Hinweis „Du wurdest woanders angemeldet“ als Vollbild über allem. Er hat genau einen Weg
// heraus: „Neu anmelden“. Solange er steht, ist die Maus frei und das Spiel nimmt keine Tasten
// mehr an – die Verbindung ist zu, und die Eingabe verlangt eine gefangene Maus
// (docs/architektur-paket-2.md, Abschnitt „Client (auth/)“).
import { HINWEIS_ANDERSWO } from './zustand.js';

export interface KickHinweisOptionen {
  /** Name des Kontos, das es getroffen hat; null, wenn er nicht bekannt ist. */
  name?: string | null;
  /** Der Knopf „Neu anmelden“ wurde gedrückt. */
  beiNeuAnmelden(): void;
}

export interface KickHinweis {
  entferne(): void;
}

export function zeigeKickHinweis(parent: HTMLElement, optionen: KickHinweisOptionen): KickHinweis {
  const wurzel = document.createElement('div');
  wurzel.className = 'kick';
  wurzel.setAttribute('role', 'alertdialog');

  const karte = document.createElement('div');
  karte.className = 'kick-karte';

  const titel = document.createElement('h1');
  titel.textContent = HINWEIS_ANDERSWO;

  const name = optionen.name ?? null;
  const text = document.createElement('p');
  text.textContent =
    name === null
      ? 'Ein Konto kann nur an einer Stelle spielen. Hier ist Schluss – melde dich neu an.'
      : `Das Konto ${name} spielt jetzt an einer anderen Stelle. Ein Konto kann nur an einer Stelle ` +
        'spielen – melde dich neu an.';

  const knopf = document.createElement('button');
  knopf.type = 'button';
  knopf.className = 'auth-knopf';
  knopf.textContent = 'Neu anmelden';
  knopf.addEventListener('click', () => optionen.beiNeuAnmelden());

  karte.append(titel, text, knopf);
  wurzel.append(karte);
  parent.append(wurzel);
  knopf.focus();

  return {
    entferne() {
      wurzel.remove();
    },
  };
}
